import React from 'react';
import cn from 'classnames';
import { glyphNames } from '@cb/apricot-react-glyph';
import { iconNames } from '@cb/apricot-react-icon';
import { Tag } from './Button';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isIcon = (x) => iconNames.includes(x);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isGlyph = (x) => glyphNames.includes(x);
export const TagSet = ({ tags, onClick, tagIcon, label, icon = 'x-mark', offScreen, small, withRegion = true, disabled, }) => {
    const tagClassName = cn(tagIcon && isIcon(tagIcon) && 'cb-icon', tagIcon && !isIcon(tagIcon) && isGlyph(icon) && 'cb-glyph', `cb-${tagIcon}`);
    return (React.createElement("div", { className: cn('cb-btn-row cb-tag-set', small && 'cb-btn-row-sm'), role: withRegion ? 'region' : undefined, "aria-label": withRegion ? label : undefined },
        tagIcon && React.createElement("span", { className: tagClassName, "aria-hidden": true }),
        tags.map((tag, key) => (React.createElement(Tag, { disabled: disabled, icon: icon, key: key, small: small, offScreen: offScreen, onClick: e => onClick && onClick(tag, e) }, tag)))));
};
//# sourceMappingURL=TagSet.js.map